// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2n3mn5G","item":"_9Lpgk6t","image":"_1xVUNXG","itemHeading":"_3GCk8qg"};